export const uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, '') // trim leading/trailing white space
  str = str.toLowerCase() // convert string to lowercase
  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-') // remove consecutive hyphens
  return str
}

export const isLightColor = (color) => {
  let r, g, b

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    const rgb = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

    r = rgb[1]
    g = rgb[2]
    b = rgb[3]
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    const hexColor = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

    r = hexColor >> 16
    g = (hexColor >> 8) & 255
    b = hexColor & 255
  }

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  // Using the HSP value, determine whether the color is light or dark
  // > 127.5 is 'light', <= 127.5 is 'dark'

  return hsp > 127.5
}
export const log = (...rest) => {
  console.log(
    '%cX-TALK-WIDGET',
    'background: #2E495E;border-radius: 0.5em;color: white;font-weight: bold;padding: 2px 0.5em;',
    ...rest
  )
}

export const replaceUrl = (url) => {
  if (!url) return url

  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}utm_id=x-talk`
}

export const mapToCorrectProduct = (product) => {
  // Determine product type based on context or source_type
  const isNewProductType = product.source_type === 'product'
  const isOldProductType = product.context === 'product' || product.document_context === 'product'
  log('isNewProductType', isNewProductType)
  log('isOldProductType', isOldProductType)
  // Handle different product structures (new API or old API format)
  if (isNewProductType && product.attributes && product.attributes.id) {
    log('New product type detected')
    // New API format
    const { attributes } = product
    return {
      ...product,
      url: replaceUrl(attributes.product_url),
      title: attributes.name?.pl || '',
      attributes: {
        id: attributes.id,
        name: attributes.name?.pl || '',
        description: attributes.description?.pl || '',
        second_line: attributes.abv_and_volume || '',
        price: attributes.price?.PLN,
        url: replaceUrl(attributes.product_url),
        thumbnail_url: attributes.image_url,
        manufacturer: attributes.manufacturer || '',
        categories: attributes.category || [],
        score: product.score || 0
      }
    }
  } else if (isOldProductType && product.attributes) {
    log('Old product type detected')
    // Old API format
    const { attributes } = product
    return {
      ...product,
      url: replaceUrl(product.url),
      title: attributes.name || '',
      attributes: {
        id: product.url?.split('/').pop().replace('.html', '') || '',
        name: attributes.name || '',
        second_line: attributes.second_line || '',
        description: attributes.description || '',
        price: attributes.price,
        url: replaceUrl(product.url),
        thumbnail_url: attributes.thumbnail_url,
        manufacturer: '',
        categories: [],
        score: product.score || 0
      }
    }
  }

  // Return empty object if product doesn't match any format
  return {}
}
